import { createUseStyles } from 'react-jss';
import { BREAKPOINTS } from '@che-ins-ui/theme';
export const INSURANCE_DESKTOP_BREAKPOINT = BREAKPOINTS.md;
export const useStyles = createUseStyles((theme) => ({
    root: {
        flexShrink: 1,
        width: '100%',
        display: 'flex',
    },
    splitter: {
        display: 'none',
        width: 'calc(13.8vw - 150px)',
        minWidth: 15,
        maxWidth: 30,
        [theme.breakpoints.up(INSURANCE_DESKTOP_BREAKPOINT)]: {
            display: 'block',
        },
    },
    content: {
        width: '100%',
    },
}), { name: 'insurance-tabs' });
